module.exports = __webpack_public_path__ + "static/img/bg-es.d00f726c.webp";